import Resource from '@/api/resources/Resource'

class IncidentOriginsConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/incidentOrigins`, filterModel, { params })
        return response.data
    }
    async getOriginsById(params) {
        const response = await this.axios.get(`/configuration/incidentOrigins/${params.id}`, { params })
        return response.data
    }
    async patchOriginsBatch(origins) {
        const response = await this.axios.patch(`/configuration/incidentOrigins/batch`, origins)
        return response.data
    }
    async createOrigin(origin) {
        const response = await this.axios.post(`/configuration/incidentOrigins`, origin)
        return response.data
    }
    async deleteOriginsBatch(origins) {
        const data = {
            entityIdentifiers: origins
        }
        const response = await this.axios.delete(`/configuration/incidentOrigins/batch`, { data: data })
        return response.data
    }
    async getWorkPhases() {
        const response = await this.axios.get(`/configuration/workPhases`)
        return response.data
    }
}

export default new IncidentOriginsConfigurationServices()
